import React, {memo} from "react";
import {Modal} from 'react-bootstrap';
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    handelCloseModalRankGuide
} from "../../../../../redux/actions/modals/modalRankGuide";
// import Slider from '@mui/material/Slider';
// import rank_guide_img from '../../../../../images/icons/ranking_guide.png';
import ic_bronze from "../../../../../images/icons/ic_bronze_36.png";
import ic_silver from "../../../../../images/icons/ic_silver_36.png";
import ic_gold from "../../../../../images/icons/ic_gold_36.png";
import {PUBLIC_URL_SERVER} from '../../../../../apis';


const ModalRankGuide = () => {
    const dispatch = useDispatch();
    // const {rank} = useSelector(state => state.user);
    const {
        statusShow
    } = useSelector(state => state.modalRankGuide);


    const handleClose = () => {
        dispatch(handelCloseModalRankGuide());
    };


	// function valuetext(value) {
	//   	return `${value}°C`;
	// }


    return (
        <BaseModal title={''} show={statusShow}
                   dialogClassName={'modal-login-and-register-custom modal-login-and-register-c-border-head'}
                   handleClose={handleClose}>
            <Modal.Body>

                <div className="row">
                    <div className="col-12 text-center">
                        <img className="mb-4" src={`${PUBLIC_URL_SERVER}/icons/fm_logo_ofoghi_new.png`} width={300} alt="fm-logo" />
                    </div>
                </div>
                
                
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <img src={ic_bronze}  alt={"برنز"} width={24} className="mx-1" />
                        برنز: 0 تا 5 سفارش
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 text-center">
                        <img src={ic_silver}  alt={"برنز"} width={24} className="mx-1" />
                        نقره‌ای: 6 تا 15 سفارش
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 text-center">
                        <img src={ic_gold}  alt={"برنز"} width={24} className="mx-1" />
                        طلایی: 16 سفارش به بالا
                    </div>
                </div>
                




                {/*
                <div className="row">
                	<div className="col-6">
                		<Slider
					        aria-label="Temperature"
					        defaultValue={rank.count_rank}
					        min={0}
  							max={5}
					        getAriaValueText={valuetext}
					        valueLabelDisplay="on"
					        disabled
					        sx={{
							    color: '#34b443 !important',
						  	}}  />
					  	<p style={{marginTop: "-20px"}}>
					  		<span className="span-left small-font">0</span>
					  		<span className="small-font">5</span>
					  	</p>
                	</div>
                	<div className="col-6 pt-2 pt-md-0">
                		<span>
                			نمره تعداد سفارش
                		</span>
                	</div>
                </div>

                <div className="row">
                	<div className="col-6">
                		<Slider
					        aria-label="Temperature"
					        defaultValue={rank.return_period}
					        min={0}
  							max={5}
					        getAriaValueText={valuetext}
					        valueLabelDisplay="on"
					        disabled
					        sx={{
							    color: '#34b443 !important',
						  	}}  />
					  	<p style={{marginTop: "-20px"}}>
					  		<span className="span-left small-font">0</span>
					  		<span className="small-font">5</span>
					  	</p>
                	</div>
                	<div className="col-6 pt-2 pt-md-0">
                		<span>
                			نمره دوره بازگشت
                		</span>
                	</div>
                </div>

                <div className="row">
                	<div className="col-6">
                		<Slider
					        aria-label="Temperature"
					        defaultValue={rank.average_rank}
					        min={0}
  							max={5}
					        getAriaValueText={valuetext}
					        valueLabelDisplay="on"
					        disabled
					        sx={{
							    color: '#34b443 !important',
						  	}}  />
					  	<p style={{marginTop: "-20px"}}>
					  		<span className="span-left small-font">0</span>
					  		<span className="small-font">5</span>
					  	</p>
                	</div>
                	<div className="col-6 pt-2 pt-md-0">
                		<span>
                			نمره میانگین سفارش
                		</span>
                	</div>
                </div>

                <div className="row">
                	<div className="col-6">
                		<Slider
					        aria-label="Temperature"
					        defaultValue={rank.total_score}
					        min={0}
  							max={15}
					        getAriaValueText={valuetext}
					        valueLabelDisplay="on"
					        disabled
					        sx={{
							    color: '#34b443 !important',
						  	}}  />
					  	<p style={{marginTop: "-20px"}}>
					  		<span className="span-left small-font">0</span>
					  		<span className="small-font">15</span>
					  	</p>
                	</div>
                	<div className="col-6 pt-2 pt-md-0">
                		<span>
                			مجموع
                		</span>
                	</div>
                </div>

                <div className="row px-2 py-4" style={{borderTop: "1px solid #d8d8d8"}}>
                	<img src={rank_guide_img} className="w-100" alt="" />
                </div>
                */}
                
            </Modal.Body>
        </BaseModal>
    )
};

export default memo(ModalRankGuide);
